$(document).ready(function(){
	function updateCartContent() {
	  // Make sure you have a template view for the cart that only outputs the cart container’s content.
	  $('.cartContentContainer').load('/cart?view=ajax .cartContentContainer > *');
	}
	// Use event delegation so new content will have events attached
	$(document).on('submit', '.product-form', function(e) {
		e.preventDefault();
		var $form = $(this);
		$.ajax({
		  type: 'POST',
		  url: $form.attr('action'),
		  data: $form.serialize(),
		  dataType: 'json',
		  success: function(cart) {
			// Refresh only the cart section after successful update
			updateCartContent();
		  },
		  error: function(xhr, status, error) {
			
			console.error("Error updating cart:", error);
		  }
		});
	  });
	  // Handler for updating cart quantities (for forms with action="/cart/update")
	  $(document).on('change', '.custom-cart-form', function(e) {
		e.preventDefault();
		var $form = $(this);
		$.ajax({
		  type: 'POST',
		  url: $form.attr('action'),
		  data: $form.serialize(),
		  dataType: 'json',
		  success: function(cart) {
			// Refresh only the cart section after successful update
			updateCartContent();
		  },
		  error: function(xhr, status, error) {
			
			console.error("Error updating cart:", error);
		  }
		});
	  });
	
	  // Handler for remove-item links (which point to /cart/change?line=...&quantity=0)
	  $(document).on('click', '.remove-item-link', function(e) {
		e.preventDefault();
		var removeUrl = $(this).attr('href'); // e.g. "/cart/change?line=2&quantity=0"
		$.ajax({
		  type: 'GET',
		  url: removeUrl,
		  dataType: 'json',
		  success: function() {
			updateCartContent();
		  },
		  error: function(xhr, status, error) {
			alert('There was an error removing the item. Please try again.');
		  }
		});
	  });
	  $(document).on('click', '.productSizeSelectorContainer a', function(e){
			if($(this).hasClass('selectQuantity')){
				var $product = $(this).closest('.singleProduct');
				// Within that container, find the first link in the .singleProductImageContainer
				var targetURL = $product.find('.singleProductImageContainer a').first().attr('href');
			  	window.location.href = targetURL;
			}
			e.preventDefault();
			var $link = $(this);
			var actionURL = $(this).attr('href');
			$.ajax({
				type: 'GET', 
				url: actionURL, 
				dataType: 'json', 
				success: function(){
					updateCartContent();
					elementSlide(".cartMenu");
				},
				error: function(xhr, status, error){
					if(!$(this).hasClass('selectQuantity')){
						alert("There was an error adding this item to your cart. Please try again.");
					}
				}
			}); 
		});
	$(".menuButtonContainer a").click(function(event){
		event.preventDefault();
		elementSlide(".mainMenu");
	});
	$(".cartLinkContainer a").click(function(event){
		event.preventDefault();
		if($(".cartMenu").hasClass("down")){
			$(".cartMenu").slideUp(500);
			$(".cartMenu").removeClass("down");
		}
		else{
			elementSlide(".cartMenu");
		}
	});
	$(".singleProductAddToCartButton").click(function(event){
		elementSlide(".cartMenu");
	});
	  $('.product-single__media-wrapper .productImage').on('mouseenter', function() {
		$(this).css({
		  'transition': 'transform 0.2s ease',
		  'transform': 'scale(2)' // Adjust the scale factor as needed
		});
	  }).on('mousemove', function(e) {
		var $img = $(this);
		// Use the immediate wrapper as the container
		var $container = $img.closest('.product-single__media-wrapper');
		var offset = $container.offset();
		var relativeX = e.pageX - offset.left;
		var relativeY = e.pageY - offset.top;
		var percentX = (relativeX / $container.width()) * 100;
		var percentY = (relativeY / $container.height()) * 100;
		// Update transform-origin so the zoom focuses on the mouse pointer
		$img.css('transform-origin', percentX + '% ' + percentY + '%');
	  }).on('mouseleave', function() {
		$(this).css({
		  'transform': 'scale(1)',
		  'transition': 'transform 0.2s ease'
		});
	  });
	  $('.smallProductMediaWrapper').on('click', function(){
		  // Check if this element does not already have the class "selectedVariant"
		  if(!$(this).hasClass('selectedVariant')){
			// Remove the class from all wrappers and add it to the clicked one
			$('.smallProductMediaWrapper').removeClass('selectedVariant');
			$(this).addClass('selectedVariant');
		  }
	  // Get the src attribute of the image inside the clicked wrapper
	  var newSrc = $(this).find('img').attr('src');
	  // Update the main product image in the product-single__media-wrapper
	  $('.product-single__media-wrapper img').attr('src', newSrc);
	});
});
function elementSlide(element){
	if(~element.indexOf("cart")){
		if($(element).attr('class') !== "down"){
			$(element).addClass("down");
			$(element).slideDown(500);
		}
		else{
			$(element).removeClass("down");
		}
		$([document.documentElement, document.body]).animate({
			scrollTop: 0
		}, 500);	
	}
	else{
		$(element).slideToggle(500);
	}
}